import { getDoc } from 'firebase/firestore/lite'
import refs from '../refsLite'

/**
 * Get a recorded error by its ID
 *
 * @param errorId
 * @returns {Promise<unknown>}
 */
export async function getError(errorId) {
  const errorDoc = await getDoc(refs.error(errorId))
  const data = errorDoc.data()
  if (!data) return null
  return { ...errorDoc.data() }
}
